import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-up', 'ArrowUp', [["path",{"d":"M12 5l0 14"}],["path",{"d":"M18 11l-6 -6"}],["path",{"d":"M6 11l6 -6"}]]);